import { FC } from 'react';

type Props = {
  message: string;
};

export const FiltersNotice: FC<Props> = ({ message }) => (
  <div className="alert alert-info client-filters__notice" role="status">
    <span className="oath-bodysmall">{message}</span>
  </div>
);
